<template>
  <div>
    <PromptControl
      @ok="logout"
      @cancel="cancel"
      @closed="closed"
      v-bind:show="prompt.show"
      v-bind:theme="prompt.theme"
      v-bind:title="prompt.title"
      v-bind:message="prompt.message"
    />
    <div v-show="display">
      <div
        v-on:click="close"
        class="w-full h-screen fixed z-sidebar-screen papsi-modal-screen"
      ></div>
      <div
        class="h-screen max-h-screen w-sidebar fixed z-sidebar papsi-sidebar-notch"
      >
        <div class="w-full h-screen flex flex-col">
          <div
            v-bind:style="[getLogo()]"
            class="h-navbar w-full bg-primary bg-contain bg-no-repeat"
          ></div>
          <div class="flex-grow overflow-auto bg-white flex flex-col">
            <div class="px-3 pt-3">
              <MenuControl
                v-for="item in modules"
                class="mt-1 mb-3"
                v-bind:href="item.href"
                v-bind:icon="item.icon"
                v-bind:key="item.id"
                @clicked="close"
              >
              <div class="menu-label mt-2 mb-2">
                {{ lang(item.label) }}
              </div>
              </MenuControl>
              <div v-on:click="openPrompt" class="bg-error rounded-lg flex">
                <div class="p-2 papsi-button-fader">
                  <div class="w-icon h-icon">
                    <img src="@/assets/icons/papsi_logout.svg" class="block" />
                  </div>
                </div>
                <div
                  class="font-bold text-sm text-white uppercase flex justify-content items-center pl-2"
                >
                  <span v-text="lang('lbl_0000123')"></span>
                </div>
              </div>
              <div v-text="version" class="pt-3 text-xs text-grey"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import MenuControl from "./../controls/MenuControl.vue";
import PromptControl from "./../controls/PromptControl.vue";
import User from "./../../services/User.js";
import mixin from "./../../mixin.js";

export default {
  name: "v-sidebar",
  mixins: [mixin],
  components: {
    MenuControl,
    PromptControl,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      display: false,
      version: null,
      modules: [
        {
          id: "mod_home",
          icon: "icons/papsi_home_grey.svg",
          href: "/dashboard",
          label: "lbl_0000083",
        },
        // {
        //   id: "mod_balance",
        //   icon: "icons/papsi_savings_grey.svg",
        //   href: "/balance/menu",
        //   label: "lbl_0000486",
        // },
        // {
        //   id: "mod_bao",
        //   icon: "icons/papsi_bank.svg",
        //   href: "/bao/menu",
        //   label: "lbl_0000502",
        // },
        {
          id: "mod_company",
          icon: "icons/papsi_company.svg",
          href: "/our-company",
          label: "lbl_0000125",
        },
        // {
        //   id: "mod_branches",
        //   icon: "icons/papsi_branches.svg",
        //   href: "/satellite-offices",
        //   label: "lbl_0000126",
        // },
        {
          id: "mod_services",
          icon: "icons/papsi_services_grey.svg",
          href: "/services",
          label: "lbl_0000296",
        },
        {
          id: "mod_events",
          icon: "icons/papsi_events.svg",
          href: "/events",
          label: "lbl_0000336",
        },
        {
          id: "mod_privacy",
          icon: "icons/papsi_help_privacy.svg",
          href: "/privacy-policy",
          label: "lbl_0000135",
        },
        {
          id: "mod_eula",
          icon: "icons/papsi_handshake.svg",
          href: "/end-user-license-agreement",
          label: "lbl_0000133",
        },
        {
          id: "mod_help",
          icon: "icons/papsi_help_dark.svg",
          href: "/help",
          label: "lbl_0000130",
        },
        
      ],
      prompt: {
        show: false,
        theme: "success",
        title: "",
        message: "",
      },
    };
  },
  mounted() {
    this.display = this.show;
    this.version = this.lang("lbl_0000044") + " " + process.env.VUE_APP_VERSION;
  },
  methods: {
    openPrompt() {
      this.prompt.title = this.lang("lbl_0000123");
      this.prompt.message = this.lang("lbl_0000124");
      this.display = false;
      this.prompt.show = true;
    },
    cancel() {
      this.display = true;
    },
    closed() {
      this.prompt.show = false;
    },
    close() {
      this.display = false;
      this.$emit("closed");
    },
    getLogo() {
      return (
        "background-image: url('" +
        this.getMediaPath("/logo/papsi-navbar-sm.png") +
        "')"
      );
    },
    logout() {
      let that = this;

      that.$emit("showloader");
      User.logout()
        .then(function () {
          that.destroyCookies();
          that.resetUserData();
          that.$emit("logout");
          that.$emit("hideloader");
          that.$router.push("/");
        })
        .catch(function (error) {
          that.$emit("error", error);
        });
    },
  },
  watch: {
    show(n) {
      this.display = n;
    },
  },
};
</script>

<style scoped>
.papsi-modal-screen {
  background-color: rgba(0, 0, 0, 0.85);
  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
  top: 0px;
  left: 0px;
}
.papsi-sidebar-notch {
  padding-top: env(safe-area-inset-top);
  padding-bottom: env(safe-area-inset-bottom);
  top: 0px;
  left: 0px;
}
.papsi-button-fader {
  background-color: rgba(255, 255, 255, 0.1);
}

.menu-label {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: anywhere; 
  line-height: 1.2rem; 
}
</style>